<div *ngIf="httpProgressBarService.isLoading | async">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>
<section class = "section">
    <mat-card>
        <span>Activating account</span>
        <mat-spinner *ngIf = "!apiError"></mat-spinner>
        <mat-error class="activate-error" *ngIf="apiError">{{ apiError }}</mat-error>
    </mat-card>
</section>